module.exports = __webpack_public_path__ + "img/c04_unitsparabara_Normal_ua.5d8bcceb.webp";